import { toRefs } from 'vue';

import { ReadonlyToRefs } from '../types/vue';

// Only compile-time readonly checks here since vue doesn't provide a readonly version of toRefs
export const toReadonlyRefs: <T extends object>(object: T) => ReadonlyToRefs<T> = toRefs;

export const toWritableRefs = toRefs;
